import { render, staticRenderFns } from "./QnaPage.vue?vue&type=template&id=0f159ee7&scoped=true&"
import script from "./QnaPage.vue?vue&type=script&lang=js&"
export * from "./QnaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f159ee7",
  null
  
)

export default component.exports